import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SidebarProvider } from "./context/SidebarContext";
import { ContactsProvider } from "./context/ContactsContext";
import { EventsProvider } from "./context/EventsContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Sidebar from "./components/sidebar/Sidebar";
import { TagsProvider } from "./context/TagsContext";

import ContactsPage from "./pages/ContactsPage";
import CalendarPage from "./pages/CalendarPage";
import TagsPage from "./pages/TagsPage";
import LoginPage from "./pages/login";
import "./App.css";

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: "2rem" }}>Lade Session...</div>;
  }

  if (!user) {
    // 🚀 Nur Login-Seite anzeigen (ohne Sidebar)
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  // 🚀 Eingeloggt: Sidebar + normale Routen
  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "1rem" }}>
        <Routes>
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="*" element={<h2>Willkommen im CRM 🚀</h2>} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <TagsProvider>
          <ContactsProvider>
            <EventsProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </EventsProvider>
          </ContactsProvider>
        </TagsProvider>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
